import { render, staticRenderFns } from "./stockVenom.vue?vue&type=template&id=22b240ca"
import script from "./stockVenom.vue?vue&type=script&lang=js"
export * from "./stockVenom.vue?vue&type=script&lang=js"
import style0 from "./stockVenom.vue?vue&type=style&index=0&id=22b240ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports